import { Component, Input, OnInit } from '@angular/core';
import { Owner } from '@app-model/owner';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-owner-list-card',
	templateUrl: './owner-list-card.component.html',
	styleUrls: ['./owner-list-card.component.scss']
})
export class OwnerListCardComponent implements OnInit {
	@Input() owner: Owner;
	defaultUrl: string;

	constructor(public translate: TranslateService) { }

	ngOnInit(): void {
		if (this.isCardholder) {
			this.defaultUrl = `/admin/cardholder/${this.owner.id}`;
		} else if (this.isGroup) {
			this.defaultUrl = `/admin/group/${this.owner.id}`;
		} else if (this.isClient) {
			this.defaultUrl = `/admin/personalization/${this.owner.id}`;
		}
	}

	get isCardholder(): boolean {
		return this.owner?.type === 'CARDHOLDER';
	}
	get isGroup(): boolean {
		return this.owner?.type === 'GROUP';
	}
	get isClient(): boolean {
		return this.owner?.type === 'CLIENT';
	}
}
